import { useSelector } from "react-redux";
import { DatapointsEntityType } from "api/ux/src";
import { objectToHash } from "common/object-helper";
import { useGetUnitOfAreaKey, useGetUserAllocationKey, useGetUserCommitmentCalculation } from "components/frame/hooks/use-user-preferences";
import { allocationKeyEnumValues, commitmentCalculationEnumValues, unitOfAreaKeyEnumValue } from "hooks/widget-data/use-datapoints";
import { gridCurrencySelector } from "store/grids";
import { FundDataExportTypes } from "./shared/dashboardTypeToEntityType";
export const getMeasuresAndDimensionsWithCurrency = (groups, datapoints) => {
    const dimensions = [], measures = [];
    for (const group of groups) {
        const datapoint = datapoints.find((d) => d.name === group);
        if (datapoint) {
            dimensions.push(datapoint);
        }
    }
    for (const datapoint of datapoints.filter((d) => !dimensions.includes(d))) {
        measures.push(datapoint);
    }
    return { dimensions, measures };
};
export const getMeasuresAndDimensionsWithoutCurrency = (datapoints) => {
    const dimensions = [], measures = [];
    for (const datapoint of datapoints) {
        measures.push(datapoint);
    }
    return { dimensions, measures };
};
export const useCreateFundsDatapointsExcelRequest = (stateId, dimensions, measures, datapointExcelOptions, totalGroupExcelOptions, isFundsTab) => {
    const allocationKey = useGetUserAllocationKey();
    const commitmentCalculation = useGetUserCommitmentCalculation();
    const unitOfArea = useGetUnitOfAreaKey();
    const selectedCurrency = useSelector((s) => gridCurrencySelector(s, stateId));
    if (!allocationKey || !commitmentCalculation || !unitOfArea) {
        return undefined;
    }
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    const requestParameters = {
        datapointsExcelRequest: {
            allocationKey: allocationKeyEnumValues(allocationKey),
            asOfDate: date,
            commitmentCalculation: commitmentCalculationEnumValues(commitmentCalculation),
            entityId: isFundsTab ? FundDataExportTypes.AllFunds : FundDataExportTypes.All,
            entityType: DatapointsEntityType.Portfolio,
            requests: [{ datapointExcelOptions, dimensions, id: "CustomFundsGrid", measures, totalGroupExcelOptions }],
            selectedCurrency,
            unitOfArea: unitOfAreaKeyEnumValue(unitOfArea)
        }
    };
    if (requestParameters.datapointsExcelRequest) {
        requestParameters.datapointsExcelRequest.id = objectToHash(requestParameters);
    }
    return requestParameters;
};
